<template>
    <button class="bg-tc-blue-4 text-white w-full rounded-full" :class="[getClass]">
        <slot></slot>
    </button>
</template>
<script>
export default {
    name: 'BlueFacebookBtn',
    props: {
        customClass: { type: String, default: null },
    },
    computed: {
        getClass: function() {
            if (this.customClass != null) {
                return this.customClass;
            }
            return 'py-10px';
        },
    },
}
</script>
<style lang="scss" scoped>
</style>
